import { CheckCircleOutline, ErrorOutline } from "@mui/icons-material";
import { Pending } from "components/Management/ModalContent";
import { translateImportJobError } from "helpers/importJobError";
import { useImportJobStatus } from "hooks/useImportJobStatus";
import { useTranslation } from "react-i18next";
import type { ImportJobStep } from "store/jobsStore";
import { ProcessingJobStatus } from "store/jobsStore";

function ImportStatusListener({
    jobId,
    onStatusUpdate,
}: {
    jobId?: number;
    onStatusUpdate?: (o: { status: ProcessingJobStatus; step: ImportJobStep; jobId: number }) => void;
}) {
    const [t] = useTranslation();

    const { jobStatus, progress, jobError } = useImportJobStatus({
        jobId,
        onStatusUpdate,
    });

    const isDone = jobStatus === ProcessingJobStatus.DONE;
    const isFailed = jobStatus === ProcessingJobStatus.FAILED || jobStatus === ProcessingJobStatus.REVERTED;
    const failureDetail = translateImportJobError(t, jobError);

    return (
        <div className="h-full flex flex-col items-center justify-center gap-2">
            {isDone ? (
                <CheckCircleOutline fontSize="large" htmlColor={"rgb(93, 173, 120)"} />
            ) : isFailed ? (
                <div className="import-status-failed">
                    <ErrorOutline fontSize="large" htmlColor="var(--danger-text)" />
                    <div className="import-status-failed-title">{t("ImportData.ImportFailed")}</div>
                    {failureDetail ? <div className="import-status-failed-detail">{failureDetail}</div> : null}
                </div>
            ) : (
                <div className="flex! flex-col! items-center! justify-center! gap-2!">
                    <Pending phrase="" />
                    <div>{t("ImportData.ValidationInProgress")}</div>
                </div>
            )}
            <div className="flex justify-center mt-3!">
                {isDone ? (
                    <span className="import-status-success">{t("ImportData.SalesImported")}</span>
                ) : isFailed ? null : (
                    <span>{progress !== null ? `${progress}%` : null}</span>
                )}
            </div>
        </div>
    );
}
export default ImportStatusListener;
